var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgContentLifecycle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 44,
    viewBox: "0 0 37 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12.833H22.0833V16.4997H7.75V12.833ZM7.75 20.1663H29.25V23.833H7.75V20.1663ZM7.75 27.4997H13.1071V31.1663H7.75V27.4997Z",
    fill: "#213867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0834 5.5L16.7084 0V3.66667H4.16671C3.21635 3.66667 2.30491 4.05298 1.63291 4.74061C0.960903 5.42824 0.583374 6.36087 0.583374 7.33333V36.6667C0.583374 37.6391 0.960903 38.5718 1.63291 39.2594C2.30491 39.947 3.21635 40.3333 4.16671 40.3333H11.3334V36.6667H4.16671V7.33333H16.7084V11L22.0834 5.5ZM14.9167 38.5L20.2917 44V40.3333H32.8334C33.7837 40.3333 34.6952 39.947 35.3672 39.2594C36.0392 38.5718 36.4167 37.6391 36.4167 36.6667V7.33333C36.4167 6.36087 36.0392 5.42824 35.3672 4.74061C34.6952 4.05298 33.7837 3.66667 32.8334 3.66667H25.6667V7.33333H32.8334V36.6667H20.2917V33L14.9167 38.5Z",
    fill: "#213867"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-178 -509)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLifecycle);
export default __webpack_public_path__ + "static/media/content-lifecycle.c626287cb8b9e4a8ea82fcb4b25456e9.svg";
export { ForwardRef as ReactComponent };